const DAYS = [
    { value: 'mon', label: 'Lu' },
    { value: 'tue', label: 'Ma' },
    { value: 'wed', label: 'Mi' },
    { value: 'thu', label: 'Jo' },
    { value: 'fri', label: 'Vi' },
    { value: 'sat', label: 'Sâ' },
    { value: 'sun', label: 'Du' },
]

export default function ProcDayPicker({ value = [], onChange }) {
    const toggle = (dayValue) => {
        onChange(value.includes(dayValue) ? value.filter((d) => d !== dayValue) : [...value, dayValue])
    }

    return (
        <div className="proc-day-picker">
            {DAYS.map((day) => (
                <button
                    key={day.value}
                    type="button"
                    className={`proc-day-chip ${value.includes(day.value) ? 'active' : ''}`.trim()}
                    onClick={() => toggle(day.value)}
                >
                    {day.label}
                </button>
            ))}
        </div>
    )
}

export const PROC_DAYS = DAYS
